import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import { HeaderTwo, P } from "../../Partials/Typography"
import VerticalSpacer from "../../Partials/VerticalSpacer"
import RightContainer from "../../Partials/RightContainer"
import { ParagraphsContainer } from "./ParagraphsContainer"
import ReactHtmlParser from "react-html-parser"
import { deviceMinW } from "../../../styles/mediaQueries"
import { fontSize } from "../../../styles/fonts/fontStyle"
import Blockquote from "./Blockquote"

const ContentBlock = ({ title, paragraphs }) => {
    return (
        <>
            <ContentBlockOuterContainer>
                <ContentBlockRightContainer>
                    {title ? (
                        <>
                            <HeaderTwo copy={title} />
                            <VerticalSpacer size="m" />
                        </>
                    ) : null}
                    <ParagraphsContainer>
                        {paragraphs.length &&
                            paragraphs.map(({ id, paragraph, bquote }) => (
                                <>
                                    <P
                                        key={id}
                                        copy={paragraph}
                                        css={css`
                                            max-width: 65ch !important;
                                            padding-bottom: 2rem;
                                            font-size: ${fontSize.longPrimer};

                                            &:last-of-type {
                                                padding-bottom: 0;
                                            }

                                            @media ${deviceMinW.tablet} {
                                                font-size: ${fontSize.bodyCopy};
                                            }
                                        `}
                                    >
                                        {ReactHtmlParser(paragraph)}
                                    </P>
                                    {bquote && (
                                        <>
                                            <Blockquote
                                                key={id}
                                                bquote={bquote}
                                            />
                                        </>
                                    )}
                                </>
                            ))}
                    </ParagraphsContainer>
                </ContentBlockRightContainer>
            </ContentBlockOuterContainer>
        </>
    )
}

export default ContentBlock

const ContentBlockOuterContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`
const ContentBlockRightContainer = styled(RightContainer)`
    flex-direction: column;
`
